import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMoisturizerGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M32.36 15.37H16.65c-1.46 0-2.65 1.18-2.65 2.64v19.34c0 1.46 1.19 2.65 2.65 2.65h15.71c1.46 0 2.64-1.19 2.64-2.64V18.01c0-1.46-1.19-2.64-2.64-2.64Zm1.14 21.98c0 .63-.51 1.14-1.14 1.14H16.65c-.63 0-1.15-.51-1.15-1.14V18.01c0-.63.51-1.15 1.15-1.15h15.71c.63 0 1.14.51 1.14 1.15v19.34ZM20.98 13.69c.41 0 .75-.34.75-.75V9.5h5.53v3.44c0 .41.34.75.75.75s.75-.34.75-.75V8.75c0-.41-.34-.75-.75-.75h-7.03c-.41 0-.75.34-.75.75v4.19c0 .41.34.75.75.75Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M26.54 26.49c-1.18-1.61-1.29-4.47-1.29-4.5a.751.751 0 0 0-.75-.73h-.01c-.41.01-.74.34-.74.75 0 .03-.02 2.68-1.36 4.46-.75.99-1.68 2.22-1.68 3.79 0 2.18 1.63 3.82 3.79 3.82 2.27 0 3.79-1.58 3.79-3.94 0-1.39-.74-2.35-1.4-3.19-.12-.15-.24-.3-.35-.46Zm-2.04 6.1c-1.33 0-2.29-.97-2.29-2.32 0-1.06.7-1.99 1.41-2.93.37-.49.65-1.02.87-1.55.21.56.49 1.11.84 1.59.12.17.25.33.38.5.58.75 1.08 1.39 1.08 2.27 0 1.53-.85 2.44-2.29 2.44Z",
    fill: "currentColor"
  }));
}

export { SvgMoisturizerGlyphSecondary as default };
